import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  IconButton,
  Menu,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Tooltip,
  OutlinedInput,
  InputLabel,
  FormControl,
  Box,
  TextField,
  FormHelperText,
  Badge,
  List,
  ListItem,
  ListItemSecondaryAction,
  Divider,
  Skeleton,
} from "@mui/material";
import { Select, Checkbox, ListItemText } from "@mui/material";
import {
  People,
  Settings,
  Notifications,
  Folder,
  Person,
  Assignment,
  Group,
  CalendarToday,
  AssignmentOutlined,
  Close,
  InfoOutlined,
} from "@mui/icons-material";
import CircularProgress from "@mui/material/CircularProgress";

import axios from "axios";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CameraIcon from "@mui/icons-material/Camera";
import { bingads, googleads } from "../assets/index";
import emptyImage from "../assets/empty.png";
import {
  fetchAndSavePriorityColumns,
  getCurrencySymbolFromISO,
} from "./config/tableHelper";
import { getPlanDetails } from "./config/apiHelper";
import { startProjectTour } from "./Tour/Tour";
import { MdPeopleAlt } from "react-icons/md";
import { RiFolderOpenFill } from "react-icons/ri";

export const DUMMYRESPONSE = [
  {
    project_id: 7,
    name: "Marketing Campaign Q4",
    category: "Marketing",
    sub_category: "Digital Ads",
    clientType: "Enterprise",
    website: null,
    created: "2025-12-16T12:53:50.000Z",
    owner_email: "owner@gmail.com",
    logged_email: "member@gmail.com",
    is_owner: 1,
    access_level: "viewer",
    total_tasks: 12,
    ad_accounts: [
      {
        id: 1,
        customer_id: "4643036315",
        account_id: null,
        campaign_start_date: "2024-01-15",
        platform: "google_ads",
        currency: "USD",
      },
    ],
  },
  {
    project_id: 10,
    name: "Test2",
    category: "Cloths",
    sub_category: "Mens",
    clientType: "Lead Gen",
    website: null,
    created: "2025-12-23T11:18:59.000Z",
    owner_email: "santoshsakre21@gmail.com",
    logged_email: "santoshsakre21@gmail.com",
    is_owner: 1,
    access_level: "owner",
    total_tasks: 3,
    ad_accounts: [],
  },
];

function convertDateToString(input) {
  if (typeof input === "string") {
    const match = input.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (match) {
      const date = new Date(input);
      if (!isNaN(date.getTime()) && date.toISOString().slice(0, 10) === input) {
        return input;
      }
    }
  }

  const date = new Date(input);

  if (date instanceof Date && !isNaN(date.getTime())) {
    return date.toISOString().slice(0, 10);
  }

  return "2020-01-01";
}

const getInitials = (name) => {
  if (!name) return "PR";
  const words = name.trim().split(" ");
  if (words.length >= 2) {
    return (words[0][0] + words[1][0]).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
};

const subCategoryOptions = {
  "Retail & E-commerce": [
    "Fashion & Apparel",
    "Footwear",
    "Electronics",
    "Beauty & Skincare",
    "Furniture & Home Decor",
    "Jewellery",
    "Eyewear",
    "Pet Supplies",
    "Kids’ Products",
    "Grocery & Essentials",
  ],
  "Health & Wellness": [
    "Supplements & Vitamins",
    "Skincare Clinics",
    "Mental Wellness Apps",
    "Fitness Equipment",
    "Weight Loss Programs",
  ],
  "Tech & Software": [
    "SaaS Tools",
    "CRM & Marketing Automation",
    "Cybersecurity Solutions",
    "Web Hosting & Domains",
    "Mobile Apps",
  ],
  "Education & Training": [
    "Online Courses",
    "Test Prep",
    "Study Abroad Consultants",
    "Coding Bootcamps",
    "Language Learning",
  ],
  "Real Estate & Home Services": [
    "Real Estate Portals",
    "Property Developers",
    "Interior Design Services",
    "Pest Control",
    "Home Cleaning Services",
  ],
  Automotive: [
    "Car Dealerships",
    "Car Rentals",
    "Electric Vehicle Brands",
    "Auto Accessories",
    "Insurance Providers",
  ],
  "Finance & Legal": [
    "Digital Banks",
    "Loan Providers",
    "Stock Trading Platforms",
    "Tax & Compliance Services",
    "Legal Services",
  ],
  "Travel & Hospitality": [
    "Flight & Hotel Booking",
    "Visa Consultants",
    "Holiday Packages",
    "Local Experiences",
    "Cruises",
  ],
  "B2B & Industrial": [
    "Logistics & Supply Chain",
    "HR & Payroll Software",
    "Industrial Equipment",
    "Business Loans & Credit",
    "Franchise Opportunities",
  ],
};
const ClientTypes = ["Lead Gen", "Revenue based"];

const ProjectList = ({ totalDaysLeft }) => {
  const { projectId } = useParams();
  const [project, setProject] = useState(null);
  const [isGoogleAdsConnected, setIsGoogleAdsConnected] = useState(false);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isGridView, setIsGridView] = useState(true);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [emailDialogOpen, setEmailDialogOpen] = useState(false);
  const [emailInput, setEmailInput] = useState("");
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const navigate = useNavigate();

  const [fetchedProjectName, setFetchedProjectName] = useState("");
  const [uniqueUserId, setUniqueUserId] = useState("");
  const [username, setUsername] = useState("");
  const [people, setPeople] = useState([]);

  // Stats State
  const [stats, setStats] = useState({
    total_projects: 0,
    personal_projects: 0,
    shared_projects: 0,
    total_tasks: 0,
  });

  // Notifications State
  const [invitations, setInvitations] = useState([]);
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [acceptingId, setAcceptingId] = useState(null);

  const email = localStorage.getItem("email");
  const [refresh, setRefresh] = useState(Math.random());

  // Fetch Project Stats
  useEffect(() => {
    const fetchProjectStats = async () => {
      if (!email) return;
      try {
        const response = await axios.post(
          "https://api.confidanto.com/projects-data/project-stats",
          { email: email },
        );
        if (response.data) {
          setStats({
            total_projects: response.data.total_projects ?? 0,
            personal_projects: response.data.personal_projects ?? 0,
            shared_projects: response.data.shared_projects ?? 0,
            total_tasks: response.data.total_tasks ?? 0,
          });
        }
      } catch (error) {
        console.error("Error fetching project stats:", error);
      }
    };

    fetchProjectStats();
  }, [email, refresh]);

  // Fetch Invitations logic
  useEffect(() => {
    const fetchInvitations = async () => {
      if (!email) return;
      try {
        const response = await axios.post(
          "https://api.confidanto.com/send-invitation-email/fetch-received-invites",
          { email: email },
        );

        let fetchedInvites = [];
        if (Array.isArray(response.data)) {
          fetchedInvites = response.data;
        } else if (response.data && Array.isArray(response.data.data)) {
          fetchedInvites = response.data.data;
        }

        const pendingInvites = fetchedInvites.filter(
          (inv) => inv.invitation_status?.toLowerCase() !== "accepted",
        );

        setInvitations(pendingInvites);
      } catch (error) {
        console.error("Error fetching invitations:", error);
      }
    };

    fetchInvitations();
  }, [email, refresh]);

  useEffect(() => {
    const fetchProjectsByEmail = async () => {
      try {
        const response = await axios.post(
          "https://api.confidanto.com/projects-data/project-list",
          { email: email },
        );

        const storedTimestamps =
          JSON.parse(localStorage.getItem("lastAccessedTimestamps")) || {};

        const updatedProjects = response.data.map((project) => {
          let imageBase64 = null;

          if (project.image) {
            if (project.image.startsWith("data:image")) {
              imageBase64 = project.image;
            } else if (project.image.startsWith("/9j/")) {
              imageBase64 = `data:image/jpeg;base64,${project.image}`;
            } else if (project.image.startsWith("iVBORw0KGgo")) {
              imageBase64 = `data:image/png;base64,${project.image}`;
            } else {
              imageBase64 = `data:image/png;base64,${project.image}`;
            }
          } else if (project.icon && project.icon.data) {
            imageBase64 = `data:image/png;base64,${btoa(
              String.fromCharCode(...new Uint8Array(project.icon.data)),
            )}`;
          }

          const adAccounts = project.ad_accounts || [];

          const googleAccount = adAccounts.find(
            (acc) =>
              acc.platform === "google_ads" || acc.platform === "dummy_ads",
          );
          const microsoftAccount = adAccounts.find(
            (acc) =>
              acc.platform === "microsoft_ad" ||
              acc.platform === "microsoft_ads",
          );

          const primaryAccount = googleAccount || microsoftAccount || {};

          const projId = project.project_id || project.id;

          return {
            ...project,
            id: projId,
            lastAccessed: storedTimestamps[projId] || project.lastAccessed,
            image: imageBase64,
            total_tasks: project.total_tasks ?? 0,

            googleAccount: googleAccount,
            microsoftAccount: microsoftAccount,

            customerId: primaryAccount.customer_id
              ? primaryAccount.customer_id
              : "Not Connected",
            platform: primaryAccount.platform,
            currency: primaryAccount.currency,
            campaign_start_date: primaryAccount.campaign_start_date,
          };
        });

        updatedProjects.sort((a, b) => b.is_owner - a.is_owner);

        setProjects(updatedProjects);

        return updatedProjects;
      } catch (error) {
        console.error("Error fetching projects:", error);
        return [];
      }
    };

    const fetchProjectById = async () => {
      try {
        const response = await axios.get(
          `https://api.confidanto.com/projects-data/projects/${projectId}`,
        );
        setProject(response.data);
        setIsGoogleAdsConnected(response.data.isGoogleAdsConnected);
      } catch (error) {
        console.error(`Error fetching project with ID ${projectId}:`, error);
      }
    };

    const runEffect = async () => {
      setLoading(true);
      try {
        if (email) {
          let data = await fetchProjectsByEmail();
          if (
            localStorage.getItem("project-tour-done") == null ||
            localStorage.getItem("project-tour-done") == false
          ) {
            setTimeout(() => {
              if (data.length <= 0) {
                startProjectTour(false);
              } else {
                startProjectTour(true);
              }

              localStorage.setItem("project-tour-done", true);
            }, 1000);
          }
        } else if (projectId) {
          await fetchProjectById();
        }

        if (email || projectId) {
          await removeCustomerIdOnPageStart();
        }
      } catch (error) {
        console.error("Error running initialization effect:", error);
      } finally {
        setLoading(false);
      }
    };
    runEffect();
  }, [email, projectId, navigate, refresh]);

  const ownedProjectsCount = projects.filter(
    (item) => item.is_owner == 1,
  ).length;
  const currentPlan = getPlanDetails();
  const projectLimitReached = ownedProjectsCount >= currentPlan.project_limit;

  const updateLastAccessed = async (projectId) => {
    const currentTimestamp = new Date().toISOString();
    setProjects((prevProjects) =>
      prevProjects.map((project) =>
        project.id === projectId
          ? { ...project, lastAccessed: currentTimestamp }
          : project,
      ),
    );
    const storedTimestamps =
      JSON.parse(localStorage.getItem("lastAccessedTimestamps")) || {};
    storedTimestamps[projectId] = currentTimestamp;
    localStorage.setItem(
      "lastAccessedTimestamps",
      JSON.stringify(storedTimestamps),
    );

    try {
      await axios.put(
        `https://api.confidanto.com/projects-data/projects/${projectId}`,
        {
          lastAccessed: currentTimestamp,
        },
      );
    } catch (error) {
      console.error("Error updating last accessed timestamp:", error);
    }
  };

  const handleMenuOpen = (event, projectId) => {
    setAnchorEl(event.currentTarget);
    setSelectedProject(projectId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedProject(null);
  };

  const [isProjectEditing, setIsProjectEditing] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    businessCategory: "",
    subcategory: "",
    clientType: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === "businessCategory") {
      setFormData((prev) => ({
        ...prev,
        businessCategory: value,
        subcategory: "",
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleEditProject = () => {
    const currentProject = projects.find((item) => item.id === selectedProject);
    if (!currentProject) {
      console.error("Project not found.");
      return;
    }
    const validCategories = Object.keys(subCategoryOptions);
    const category =
      validCategories.find(
        (c) => c.toLowerCase() === currentProject.category?.toLowerCase(),
      ) || "";
    let subcategory = "";
    if (
      category &&
      subCategoryOptions[category]?.includes(currentProject.sub_category)
    ) {
      subcategory = currentProject.sub_category;
    }
    const clientType = ClientTypes.includes(currentProject.clientType)
      ? currentProject.clientType
      : "";

    setFormData({
      name: currentProject.name || "",
      businessCategory: category,
      subcategory: subcategory,
      clientType: clientType,
    });
    setIsProjectEditing(true);
  };

  const saveEditedProject = () => {
    axios
      .post("https://api.confidanto.com/projects-data/update-project", {
        id: selectedProject,
        email: localStorage.getItem("email"),
        name: formData.name,
        category: formData.businessCategory,
        sub_category: formData.subcategory,
        client_type: formData.clientType,
      })
      .then((res) => {})
      .catch((err) => console.error("Error Saving Project", err))
      .finally((fin) => {
        setIsProjectEditing(false);
        setSelectedProject(null);
        setRefresh(Math.random());
        handleMenuClose();
      });
  };

  const isFormValid =
    formData.name.trim() !== "" &&
    formData.businessCategory !== "" &&
    formData.clientType !== "";

  const nameError = formData.name.trim() === "";
  const categoryError = formData.businessCategory === "";
  const clientTypeError = formData.clientType === "";

  const handleDeleteProject = async () => {
    setDeleteDialogOpen(true);
  };

  const confirmDeleteProject = async () => {
    try {
      await axios.delete(
        `https://api.confidanto.com/projects-data/delete-project`,
        {
          data: {
            id: selectedProject,
            email: email,
          },
        },
      );
      try {
        await axios.delete(
          "https://api.confidanto.com/connect-google-ads/revoke-connected-account",
          {
            data: {
              email: email,
              project_id: selectedProject,
            },
          },
        );
      } catch (e) {}
      setProjects(projects.filter((project) => project.id !== selectedProject));
      handleMenuClose();
      setDeleteDialogOpen(false);
      setRefresh(Math.random());
    } catch (error) {
      console.error("Error deleting project:", error);
    }
  };

  const handleFileUpload = async (event, projectId) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("image", file);
      try {
        await axios.put(
          `https://api.confidanto.com/projects-data/projects/${projectId}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );
        let updatedProjects = projects.map((project) =>
          project.id === projectId
            ? { ...project, image: URL.createObjectURL(file) }
            : project,
        );
        setProjects(updatedProjects);
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    }
  };

  const handleNewProjectClick = () => {
    navigate("/create-project");
  };

  const formatDate = (dateString) => {
    if (!dateString) return "Not Accessed Yet";

    const date = new Date(dateString);
    const now = new Date();

    if (isNaN(date.getTime())) return "Invalid Date";
    const today = now.toDateString();
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);

    if (date.toDateString() === today) {
      return `Today at ${date.toLocaleTimeString(undefined, {
        hour: "2-digit",
        minute: "2-digit",
      })}`;
    } else if (date.toDateString() === yesterday.toDateString()) {
      return "Yesterday";
    } else {
      return date.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    }
  };

  const handleProjectTitleClick = async (
    projectId,
    customer_id,
    project_name,
    currency,
    campaign_start_date,
    platform,
    project,
    type = "google_ads",
  ) => {
    const FALLBACK_ID = 13;

    const isGoogle = type === "google_ads";
    const googleId = project?.ad_accounts?.[0]?.id;
    const microsoftId = project?.microsoftAccount?.id;

    const adAccountId = (isGoogle ? googleId : microsoftId) ?? FALLBACK_ID;

    const platformConnected = {
      google_ads: project?.ad_accounts?.some(
        (item) =>
          item.platform === "dummy_ads" || item.platform === "google_ads",
      ),
      microsoft_ads: project?.ad_accounts?.some(
        (item) =>
          item.platform === "microsoft_ads" || item.platform === "bing_ads",
      ),
    };
    const currencySymbol = currency
      ? getCurrencySymbolFromISO(currency)
      : getCurrencySymbolFromISO("USD");

    const formattedDate = convertDateToString(campaign_start_date);

    const storageItems = {
      ad_account_id: adAccountId,
      start_date: formattedDate,
      currency_symbol: currencySymbol,
      project_id: projectId,
      customer_id: customer_id,
      project_name: project_name,
      platform: platform,
      platform_connected: JSON.stringify(platformConnected),
    };

    Object.entries(storageItems).forEach(([key, value]) => {
      localStorage.setItem(key, value);
    });

    try {
      await Promise.all([
        updateLastAccessed(projectId),
        fetchAndSavePriorityColumns(),
      ]);
    } catch (error) {
      console.error("Background project setup failed", error);
    }

    navigate(`/project-details/${projectId}`);
    window.dispatchEvent(new Event("localStorageChange"));
  };

  const removeCustomerIdOnPageStart = () => {
    localStorage.removeItem("project_name");
    window.dispatchEvent(
      new CustomEvent("localStorageChange", { detail: { key: "customer_id" } }),
    );

    localStorage.removeItem("project_name");

    window.dispatchEvent(
      new CustomEvent("localStorageChange", {
        detail: { key: "project_name" },
      }),
    );
  };

  const [peopleWithAccess, setPeopleWithAccess] = useState([]);
  const fetchSharedProjectEmail = (projectId, customerId) => {
    axios
      .post(
        "https://api.confidanto.com/projects-data/get-shared-project-email",
        {
          project_id: projectId,
          email: localStorage.getItem("email"),
        },
      )
      .then((res) => {
        setPeopleWithAccess(res.data);
      })
      .catch((err) => {
        console.error("Error Fetching Email List", err);
      });
  };

  const [userList, setUserList] = useState([]);
  const fetchAccessibleEmailList = (projectId, customerId) => {
    axios
      .post(
        "https://api.confidanto.com/projects-data/get-accessible-email-list",
        {
          customer_id: customerId,
          project_id: projectId,
          email: localStorage.getItem("email"),
          ad_account_id: localStorage.getItem("ad_account_id"),
        },
      )
      .then((res) => {
        setUserList(res.data);
      })
      .catch((err) => {
        console.error("Error Fetching Accessible List", err);
      });
  };

  const handleAddPeopleClick = async (projectId, customerId, projectName) => {
    setCurrentProjectId(projectId);
    setEmailDialogOpen(true);

    await fetchSharedProjectEmail(projectId, customerId);
    await fetchAccessibleEmailList(projectId, customerId);
    fetch("https://api.confidanto.com/fetch-user-project-data", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
        projectId: projectId,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const { user, project } = data;
        setFetchedProjectName(project?.name || "");
        setUniqueUserId(user?.unique_user_id || "");
        setUsername(user?.username || "");
      })
      .catch((error) => {
        setFetchedProjectName(projectName);
        console.error("Error fetching user/project data:", error.message);
      });
  };

  const handleCreateTask = async (projectId, project_name) => {
    localStorage.setItem("project_name", project_name);
    localStorage.setItem("project_id", projectId);
    await updateLastAccessed(projectId);
    navigate(`/create-task/${projectId}`);
  };

  const handleEmailDialogClose = () => {
    setEmailDialogOpen(false);
    setEmailInput("");
    setCurrentProjectId(null);
    setPeople([]);
  };

  const [emailSending, setEmailSending] = useState(false);
  const [currentAccessType, setCurrentAccessType] = useState("Admin");
  const [currentEngineType, setCurrentEngineType] = useState("google_ads");

  const toggleProjectAccess = (isInvitation, revokeEmail) => {
    if (currentProjectId && (emailInput || isInvitation == false)) {
      let requestBody = {
        inviteFrom: email,
        email: emailInput,
        userId: uniqueUserId,
        accountName: username,
        projectName: fetchedProjectName,
        projectId: currentProjectId,
        access_level: currentAccessType.toLowerCase(),
        currentEngineType: currentEngineType,
      };

      if (isInvitation) {
        requestBody = { ...requestBody, action: "send-invitation" };
      } else {
        requestBody = {
          action: "revoke",
          inviteFrom: email,
          projectId: currentProjectId,
          email: revokeEmail,
        };
      }

      setEmailSending(true);
      fetch("https://api.confidanto.com/send-invitation-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          setEmailSending(false);
          alert("Invitation email sent successfully...!", data);
        })
        .catch((error) => {
          console.error("Error sending invitation email:", error.message);
        })
        .finally((fin) => {
          setEmailSending(false);
          handleEmailDialogClose();
        });
    }
  };

  const handleGoogleAdsIconClick = async (projectId, customerId) => {
    localStorage.setItem("project_id", projectId);
    navigate(`/connect-with-Googleads`, { state: { step: 2 } });
  };

  const handleAcceptInvitation = async (invProjectId) => {
    setAcceptingId(invProjectId);
    try {
      await axios.post(
        "https://api.confidanto.com/send-invitation-email/accept-invitation",
        {
          project_id: invProjectId,
          invitedEmail: email,
        },
      );
      setRefresh(Math.random());
    } catch (error) {
      console.error("Error accepting invitation:", error);
    } finally {
      setAcceptingId(null);
    }
  };

  return (
    <div className="flex justify-center md:px-4 px-4 py-8 md:py-4 min-h-screen">
      <div className="w-full max-w-screen-xl">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-4">
          <div className="flex items-center gap-2">
            <div className="w-11 h-11 md:w-12 md:h-12 rounded-md bg-transparent text-blue-600 flex items-center justify-center shrink-0 ">
              <RiFolderOpenFill className="!text-5xl" />
            </div>
            <div>
              <h1 className="text-2xl md:text-3xl font-bold text-gray-900 tracking-tight leading-tight">
                Project List
              </h1>
              <p className="text-sm text-gray-500 font-normal">
                Manage and monitor all your projects in one place.
              </p>
            </div>
          </div>

          <div className="flex flex-row items-center gap-4 w-full md:w-auto justify-end">
            {false && (
              <Tooltip title={`${invitations.length} unaccepted invitation(s)`}>
                <IconButton
                  onClick={() => setNotificationsOpen(true)}
                  color="primary"
                  className="bg-gray-50 hover:bg-gray-200 transition-colors"
                >
                  <Badge badgeContent={invitations.length} color="error">
                    <Notifications />
                  </Badge>
                </IconButton>
              </Tooltip>
            )}

            <Tooltip title={projectLimitReached ? "Project limit reached" : ""}>
              <span className="w-full md:w-auto inline-block">
                <button
                  onClick={handleNewProjectClick}
                  disabled={projectLimitReached}
                  id="create-project"
                  className="bg-[#4142dc] px-4 py-2 text-base text-white font-semibold rounded-lg hover:shadow-lg hover:shadow-[#4142dc] w-full md:w-auto disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {projects.length === 0 && !loading
                    ? "Create Project"
                    : "Add Project"}
                </button>
              </span>
            </Tooltip>
          </div>
        </div>

        {/* Stats Cards Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-8">
          {/* Card 1: Total Projects */}
          <div className="bg-white p-5 rounded-md border border-gray-100 shadow-sm flex items-center space-x-4">
            <div className="w-12 h-12 rounded-full bg-blue-50 text-blue-600 flex items-center justify-center shrink-0">
              <Folder />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">
                Total Projects
              </p>
              <h3 className="text-2xl font-bold text-gray-800">
                {loading ? <Skeleton width={40} /> : stats.total_projects}
              </h3>
            </div>
          </div>

          {/* Card 2: Personal Projects */}
          <div className="bg-white p-5 rounded-md border border-gray-100 shadow-sm flex items-center space-x-4">
            <div className="w-12 h-12 rounded-full bg-emerald-50 text-emerald-600 flex items-center justify-center shrink-0">
              <Person />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">
                Personal Projects
              </p>
              <h3 className="text-2xl font-bold text-gray-800">
                {loading ? <Skeleton width={40} /> : stats.personal_projects}
              </h3>
            </div>
          </div>

          {/* Card 3: Shared Projects */}
          <div className="bg-white p-5 rounded-md border border-gray-100 shadow-sm flex items-center space-x-4">
            <div className="w-12 h-12 rounded-full bg-purple-50 text-purple-600 flex items-center justify-center shrink-0">
              <Group />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">
                Shared Projects
              </p>
              <h3 className="text-2xl font-bold text-gray-800">
                {loading ? <Skeleton width={40} /> : stats.shared_projects}
              </h3>
            </div>
          </div>

          {/* Card 4: Total Tasks */}
          <div className="bg-white p-5 rounded-md border border-gray-100 shadow-sm flex items-center space-x-4">
            <div className="w-12 h-12 rounded-full bg-amber-50 text-amber-600 flex items-center justify-center shrink-0">
              <Assignment />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">Total Tasks</p>
              <h3 className="text-2xl font-bold text-gray-800">
                {loading ? <Skeleton width={40} /> : stats.total_tasks}
              </h3>
            </div>
          </div>
        </div>

        {/* Projects Cards / Skeleton Loading / Empty State */}
        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
            {[...Array(6)].map((_, index) => (
              <div
                key={index}
                className="bg-white rounded-lg border border-gray-100 shadow-sm p-5 flex flex-col justify-between h-[280px]"
              >
                {/* Skeleton Top Row */}
                <div className="flex justify-between items-center mb-2">
                  <Skeleton
                    variant="rounded"
                    width={80}
                    height={24}
                    sx={{ borderRadius: "9999px" }}
                  />
                  <Skeleton variant="circular" width={24} height={24} />
                </div>

                {/* Skeleton Middle Section */}
                <div className="flex flex-col items-center text-center my-auto">
                  <Skeleton
                    variant="circular"
                    width={64}
                    height={64}
                    className="mb-3"
                  />
                  <Skeleton
                    variant="text"
                    width="60%"
                    height={28}
                    className="mb-1"
                  />
                  <Skeleton
                    variant="text"
                    width="45%"
                    height={18}
                    className="mb-3"
                  />
                  <Skeleton
                    variant="rounded"
                    width={90}
                    height={22}
                    sx={{ borderRadius: "9999px" }}
                  />
                </div>

                {/* Skeleton Footer */}
                <div className="border-t border-gray-100 pt-3 flex items-center justify-between -mx-5 -mb-5 px-5 py-3.5 bg-gray-50/40">
                  <Skeleton variant="text" width={70} height={20} />
                  <Skeleton
                    variant="rounded"
                    width={85}
                    height={26}
                    sx={{ borderRadius: "8px" }}
                  />
                </div>
              </div>
            ))}
          </div>
        ) : projects.length === 0 ? (
          <div className="flex flex-col items-center justify-center min-h-fit">
            <img
              src={emptyImage}
              alt="No projects available"
              className="w-1/3 h-1/3"
            />
            <p className="text-gray-600 mt-0 text-center mr-20">
              No projects available.
            </p>
          </div>
        ) : (
          <div
            className={
              isGridView
                ? "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-6"
                : "flex flex-col space-y-6 mb-6"
            }
          >
            {projects.map((project) => (
              <div
                key={project.id}
                className="bg-white rounded-lg border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 flex flex-col justify-between overflow-hidden relative"
              >
                {/* Card Top Row: Ad accounts pill & menu */}
                <div className="p-5 pb-1 flex justify-between items-center">
                  <div className="flex items-center gap-2 bg-gray-50 border border-gray-100 px-2.5 py-1 rounded-full">
                    {project.is_owner ? (
                      <>
                        <Tooltip
                          title={
                            project.googleAccount
                              ? `Google Ads Customer ID: ${project.googleAccount.customer_id}`
                              : "Connect with Google Ads"
                          }
                          arrow
                        >
                          <button
                            disabled={!!project.googleAccount}
                            onClick={() =>
                              handleGoogleAdsIconClick(
                                project.id,
                                project.googleAccount?.customer_id,
                              )
                            }
                            className="flex items-center justify-center"
                          >
                            <img
                              src={googleads}
                              alt="Google Ads"
                              className={`h-4 w-auto transition-all ${
                                project.googleAccount
                                  ? "grayscale opacity-40"
                                  : "grayscale-0"
                              }`}
                            />
                          </button>
                        </Tooltip>
                        <Tooltip
                          title={
                            project.microsoftAccount
                              ? `Bing Ads Customer ID: ${project.microsoftAccount.customer_id}`
                              : "Connect with Bing Ads"
                          }
                          arrow
                        >
                          <button
                            disabled={!!project.microsoftAccount}
                            onClick={() =>
                              handleGoogleAdsIconClick(
                                project.id,
                                project.microsoftAccount?.customer_id,
                              )
                            }
                            className="flex items-center justify-center"
                          >
                            <img
                              src={bingads}
                              alt="Bing Ads"
                              className={`h-4 w-auto transition-all ${
                                project.microsoftAccount
                                  ? "grayscale opacity-40"
                                  : "grayscale-0"
                              }`}
                            />
                          </button>
                        </Tooltip>
                      </>
                    ) : (
                      <Tooltip
                        title="Shared Project: You have been granted access by the owner"
                        arrow
                        placement="top"
                      >
                        <div className="flex items-center text-emerald-700 text-xs font-medium gap-1">
                          <MdPeopleAlt size={14} />
                          <span>Shared</span>
                        </div>
                      </Tooltip>
                    )}
                  </div>

                  {project.is_owner ? (
                    <IconButton
                      size="small"
                      onClick={(e) => handleMenuOpen(e, project.id)}
                      className="text-gray-400 hover:text-gray-600"
                    >
                      <MoreVertIcon fontSize="small" />
                    </IconButton>
                  ) : (
                    <></>
                  )}
                </div>

                {/* Card Middle Section */}
                <div className="px-5 py-2 flex flex-col items-center text-center">
                  {/* Avatar / Logo */}
                  <div className="relative mb-3">
                    <input
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      id={`icon-upload-${project.id}`}
                      onChange={(event) => handleFileUpload(event, project.id)}
                    />
                    <label
                      htmlFor={`icon-upload-${project.id}`}
                      className="cursor-pointer inline-block"
                    >
                      <div className="w-16 h-16 rounded-full border-2 border-gray-100 bg-blue-50 text-blue-600 flex items-center justify-center font-bold text-xl overflow-hidden shadow-xs hover:border-blue-300 transition-all">
                        {project.image ? (
                          <img
                            src={project.image}
                            alt={project.name}
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          getInitials(project.name)
                        )}
                      </div>
                    </label>
                  </div>

                  {/* Project Name */}
                  {project.customerId &&
                  project.customerId !== "Not Connected" ? (
                    <Tooltip
                      title={
                        project.is_owner && totalDaysLeft <= 0
                          ? "Plan has expired"
                          : ""
                      }
                      placement="top"
                    >
                      <button
                        onClick={() =>
                          handleProjectTitleClick(
                            project.id,
                            project.customerId,
                            project.name,
                            project.currency,
                            project.campaign_start_date,
                            project.platform,
                            project,
                          )
                        }
                        disabled={project.is_owner && totalDaysLeft <= 0}
                        className={`text-lg font-bold text-slate-900 hover:text-blue-600 transition-colors mb-1 ${
                          project.is_owner && totalDaysLeft <= 0
                            ? "cursor-not-allowed opacity-50"
                            : ""
                        }`}
                      >
                        {project.name}
                      </button>
                    </Tooltip>
                  ) : (
                    <h2
                      className="text-lg font-bold text-slate-800 mb-1"
                      title="Connect Google Ads to open"
                    >
                      {project.name}
                    </h2>
                  )}

                  {/* Last Accessed */}
                  <div className="flex items-center gap-1.5 text-xs text-gray-400 mb-3">
                    <CalendarToday style={{ fontSize: 13 }} />
                    <span>
                      Last Accessed: {formatDate(project.lastAccessed)}
                    </span>
                  </div>

                  {/* Category Pill */}
                  {project.category && (
                    <span className="bg-emerald-50 text-emerald-700 text-xs font-medium px-3.5 py-1 rounded-full border border-emerald-100/60 inline-block">
                      {project.category}
                    </span>
                  )}
                </div>

                {/* Card Bottom Footer Row */}
                <div className="border-t border-gray-100 px-5 py-3.5 flex items-center justify-between bg-gray-50/40 mt-3">
                  {/* Left: Add People */}
                  <div>
                    {project.is_owner ? (
                      <button
                        onClick={() =>
                          handleAddPeopleClick(
                            project.id,
                            project.customerId,
                            project.name,
                          )
                        }
                        className="text-xs font-semibold text-gray-600 hover:text-blue-600 transition-colors flex items-center gap-1.5"
                      >
                        <MdPeopleAlt size={16} className="text-gray-400" />
                        <span>Add People</span>
                      </button>
                    ) : (
                      <span className="text-xs text-gray-400 font-medium">
                        Shared Access
                      </span>
                    )}
                  </div>

                  {/* Right: Total Tasks */}
                  <button
                    onClick={() => handleCreateTask(project.id, project.name)}
                    className="text-xs font-semibold text-blue-600 hover:text-blue-700 transition-colors flex items-center gap-1.5 bg-blue-50/80 px-2.5 py-1 rounded-lg"
                  >
                    <AssignmentOutlined style={{ fontSize: 15 }} />
                    <span>{project.total_tasks ?? 0} Tasks</span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Invites Notifications Dialog */}
      <Dialog
        open={notificationsOpen}
        onClose={() => setNotificationsOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Project Invitations</DialogTitle>
        <DialogContent dividers>
          {invitations.length === 0 ? (
            <p className="text-gray-500 text-center py-4">
              No unaccepted invitations.
            </p>
          ) : (
            <List>
              {invitations.map((invite, index) => (
                <React.Fragment key={index}>
                  <ListItem>
                    <ListItemText
                      primary={`Project: ${invite.project_name || invite.projectName || "Unknown Project"}`}
                      secondary={`Invited by: ${invite.project_owner_email || invite.inviteFrom || "Unknown Email"} ${invite.access_level ? `| Role: ${invite.access_level}` : ""}`}
                    />
                    <ListItemSecondaryAction>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        disabled={acceptingId === invite.project_id}
                        onClick={() =>
                          handleAcceptInvitation(invite.project_id)
                        }
                      >
                        {acceptingId === invite.project_id
                          ? "Accepting..."
                          : "Accept"}
                      </Button>
                    </ListItemSecondaryAction>
                  </ListItem>
                  {index < invitations.length - 1 && <Divider />}
                </React.Fragment>
              ))}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setNotificationsOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handleEditProject}>
          <EditIcon fontSize="small" />
          Edit
        </MenuItem>
        <MenuItem onClick={handleDeleteProject}>
          <DeleteIcon fontSize="small" />
          Delete
        </MenuItem>
      </Menu>
      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this project?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmDeleteProject} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isProjectEditing}
        onClose={() => setIsProjectEditing(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Edit Project</DialogTitle>
        <DialogContent>
          <Box component="form" noValidate autoComplete="off" sx={{ mt: 1 }}>
            <TextField
              autoFocus
              required
              margin="dense"
              id="name"
              name="name"
              label="Project Name"
              type="text"
              fullWidth
              variant="outlined"
              value={formData.name}
              onChange={handleInputChange}
              error={nameError}
              helperText={nameError ? "Project name is required" : ""}
            />

            <FormControl
              fullWidth
              margin="dense"
              required
              error={categoryError}
            >
              <InputLabel id="business-category-label">
                Business Category
              </InputLabel>
              <Select
                labelId="business-category-label"
                id="businessCategory"
                name="businessCategory"
                value={formData.businessCategory}
                label="Business Category"
                onChange={handleInputChange}
              >
                {Object.keys(subCategoryOptions).map((category) => (
                  <MenuItem key={category} value={category}>
                    {category}
                  </MenuItem>
                ))}
              </Select>
              {categoryError && (
                <FormHelperText>Business category is required</FormHelperText>
              )}
            </FormControl>

            <FormControl
              fullWidth
              margin="dense"
              disabled={!formData.businessCategory}
            >
              <InputLabel id="subcategory-label">Subcategory</InputLabel>
              <Select
                labelId="subcategory-label"
                id="subcategory"
                name="subcategory"
                value={formData.subcategory}
                label="Subcategory"
                onChange={handleInputChange}
              >
                {(subCategoryOptions[formData.businessCategory] || []).map(
                  (sub) => (
                    <MenuItem key={sub} value={sub}>
                      {sub}
                    </MenuItem>
                  ),
                )}
              </Select>
            </FormControl>

            <FormControl
              fullWidth
              margin="dense"
              required
              error={clientTypeError}
            >
              <InputLabel id="client-type-label">Client Type</InputLabel>
              <Select
                labelId="client-type-label"
                id="clientType"
                name="clientType"
                value={formData.clientType}
                label="Client Type"
                onChange={handleInputChange}
              >
                {ClientTypes.map((item) => (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
              {clientTypeError && (
                <FormHelperText>Client type is required</FormHelperText>
              )}
            </FormControl>
          </Box>
        </DialogContent>

        <DialogActions sx={{ p: "16px 24px" }}>
          <Button onClick={() => setIsProjectEditing(false)}>Close</Button>
          <Button
            onClick={saveEditedProject}
            variant="contained"
            disabled={!isFormValid}
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>

      {/* Share / Add People Dialog */}
      <Dialog
        open={emailDialogOpen}
        onClose={handleEmailDialogClose}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: "16px",
            p: 1,
          },
        }}
      >
        {emailSending && (
          <div className="absolute inset-0 bg-white/70 backdrop-blur-[1px] flex flex-col justify-center items-center z-50 rounded-2xl">
            <CircularProgress size="3.5rem" />
          </div>
        )}

        <DialogTitle sx={{ px: 3, pt: 2.5, pb: 1 }}>
          <div className="flex justify-between items-start">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-blue-50 text-[#4142dc] flex items-center justify-center shrink-0 border border-blue-100/60 shadow-xs">
                <People className="!text-2xl" />
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900 leading-tight">
                  Share "{fetchedProjectName}"
                </h3>
                <p className="text-xs text-gray-500 font-normal mt-0.5">
                  Invite people to collaborate on this project.
                </p>
              </div>
            </div>
            <IconButton
              onClick={handleEmailDialogClose}
              size="small"
              className="text-gray-400 hover:text-gray-600 !bg-gray-50 hover:!bg-gray-100"
            >
              <Close fontSize="small" />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent sx={{ px: 3, py: 1.5 }} className="z-0">
          <div className="flex flex-row justify-center items-center space-x-2 mb-3">
            <FormControl className="w-2/4 z-0" margin="dense">
              <InputLabel id="email-select-label">Select Email</InputLabel>
              <Select
                labelId="email-select-label"
                id="email-select"
                value={emailInput}
                onChange={(e) => setEmailInput(e.target.value)}
                input={<OutlinedInput label="Select Email" />}
                startAdornment={<People className="mr-2" />}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 300,
                    },
                  },
                }}
              >
                {userList.map((person) => (
                  <MenuItem key={person.user_id} value={person.email}>
                    {person.email}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl className="w-1/4">
              <InputLabel>Access Type</InputLabel>
              <Select
                value={currentAccessType}
                onChange={(e) => {
                  setCurrentAccessType(e.target.value);
                }}
                renderValue={(selected) => selected}
                input={<OutlinedInput label="Access Type" />}
              >
                <MenuItem key={1} value={"Admin"}>
                  <Checkbox checked={currentAccessType === "Admin"} />
                  <ListItemText primary={"Admin"} />
                </MenuItem>
                <MenuItem key={2} value={"Standard"}>
                  <Checkbox checked={currentAccessType === "Standard"} />
                  <ListItemText primary={"Standard"} />
                </MenuItem>
              </Select>
            </FormControl>

            <FormControl className="w-1/4">
              <InputLabel>Engine Type</InputLabel>
              <Select
                value={currentEngineType}
                onChange={(e) => {
                  setCurrentEngineType(e.target.value);
                }}
                renderValue={(selected) =>
                  selected === "google_ads" ? "Google Ads" : "Bing Ads"
                }
                input={<OutlinedInput label="Engine Type" />}
              >
                <MenuItem key={1} value={"google_ads"}>
                  <Checkbox checked={currentEngineType === "google_ads"} />
                  <ListItemText primary={"Google Ads"} />
                </MenuItem>
                <MenuItem key={2} value={"bing_ads"}>
                  <Checkbox checked={currentEngineType === "bing_ads"} />
                  <ListItemText primary={"Bing Ads"} />
                </MenuItem>
              </Select>
            </FormControl>
          </div>

          {/* Blue Note Banner */}
          <div className="flex items-center gap-2 bg-[#f0f6ff] border border-[#dbe8fc] text-[#3b5998] px-3.5 py-2.5 rounded-lg mb-4 text-xs font-normal">
            <InfoOutlined className="text-blue-500 !text-lg shrink-0" />
            <span>
              <strong className="font-semibold text-gray-800">Note:</strong>{" "}
              Only people explicitly granted access can use Google Ads for this
              project.
            </span>
          </div>

          <div className="mt-4">
            <h3 className="text-sm font-semibold mb-2">People with access</h3>
            <div className="flex justify-between items-center py-2">
              <div className="flex items-center w-full">
                <div className="flex items-center justify-center w-8 h-8 bg-[#da627d] text-white rounded-full">
                  {email ? email.charAt(0).toUpperCase() : ""}
                </div>
                <div className="ml-3 flex w-full justify-between items-center">
                  <div className="flex flex-col">
                    <p className="text-sm text-gray-500">{username}</p>
                    <p className="text-sm text-gray-500">{email}</p>
                  </div>
                  <p className="text-sm text-gray-500">Owner</p>
                </div>
              </div>
            </div>
            {peopleWithAccess.length > 0 && (
              <>
                {peopleWithAccess
                  .filter(
                    (person) =>
                      person.invited_user_email !== person.owner_email,
                  )
                  .map((person, index) => (
                    <div
                      key={index}
                      className="flex justify-between items-center py-2"
                    >
                      <div className="flex items-center w-full">
                        <div className="flex items-center justify-center w-8 h-8 bg-blue-500 text-white rounded-full">
                          {person.invited_user_email.charAt(0).toUpperCase()}
                        </div>
                        <div className="ml-3 flex w-full justify-between">
                          <p className="text-sm text-gray-500 text-center">
                            {person.invited_user_email}
                          </p>
                          <p className="text-sm text-gray-500 text-center">
                            {person.invitation_status}
                          </p>
                          <button
                            className="text-sm text-red-500"
                            onClick={() => {
                              toggleProjectAccess(
                                false,
                                person.invited_user_email,
                              );
                            }}
                          >
                            Revoke Access
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
              </>
            )}
          </div>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <div className="flex justify-between w-full">
            <Button
              onClick={handleEmailDialogClose}
              variant="outlined"
              color="primary"
              sx={{ borderRadius: "50px", px: 3 }}
              disabled={emailSending}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                toggleProjectAccess(true);
              }}
              variant="contained"
              color="primary"
              sx={{ borderRadius: "50px", px: 4 }}
              disabled={emailSending}
            >
              Done
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ProjectList;
